/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds: p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-04-28T03:18:17.994Z
 */

declare const __SSR_REGION__: string | undefined;

// prettier-ignore
const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'BlogTreeRootComponentQuery', // 3
	'CollabDraftQuery', // 4
	'ContentBlogUnifiedQuery', // 5
	'ContentHeaderPresenceContentSettingsQuery', // 6
	'ContentHeaderUnifiedQuery', // 7
	'ContentTypesHeaderQuery', // 8
	'ContentUnifiedQuery', // 9
	'ContentUnifiedWithSpaceKeyQuery', // 10
	'CookieConsentPreferences', // 11
	'CoverPictureQuery', // 12
	'CustomHeaderFooterQuery', // 13
	'DatabaseContainerQuery', // 14
	'EditContentButtonQuery', // 15
	'EditorContentStateQuery', // 16
	'EditorPreferencesQuery', // 17
	'EmojiTitleQuery', // 18
	'EndOfPageRecommendationQuery', // 19
	'FooterCreateButtonsQuery', // 20
	'ForgeExtensionList', // 21
	'LegacyMacroRendererQueryBodyQuery', // 22
	'LivePagesByLineLastUpdatedQuery', // 23
	'LocalStorageQuery', // 24
	'NativeCollabQuery', // 25
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 26
	'PageRestrictionsContextQuery', // 27
	'PageTreeQuery', // 28
	'PageTreeQueryWithSpaceKeyQuery', // 29
	'PermissionCheckAddCommentQuery', // 30
	'PersistentInviteEligibleQuery', // 31
	'PersonalizedTemplatesV2AllTemplatesQuery', // 32
	'Preferences', // 33
	'ReactionsContentQuery', // 34
	'RecentlyUpdatedMacroQuery', // 35
	'RendererContentStateQuery', // 36
	'RestrictedPageWithCanViewQuery', // 37
	'ScreenQuery', // 38
	'SiteInformationQuery', // 39
	'SmartCreateFeedbackBannerQuery', // 40
	'SmartCreatePageEditorDataWrapperComponentQuery', // 41
	'SpaceNavigationQuery', // 42
	'SpaceOverviewIdQuery', // 43
	'SpaceOverviewQuery', // 44
	'SpaceQuery', // 45
	'SpaceRestrictionCheckQuery', // 46
	'ThemeQuery', // 47
	'TopNavigationQuery', // 48
	'UserSettingsQuery', // 49
	'ViewSpaceExternalCollaboratorsDialogQuery', // 50
	'WebItemLocationQuery_page.metadata.banner', // 51
	'WebItemLocationQuery_system.content.byline', // 52
	'WebItemLocationQuery_system.header_left', // 53
	'WebItemLocationQuery_system.header_left_system.user', // 54
	'WebPanelLocationQuery_atl.footer', // 55
	'WebPanelLocationQuery_atl.general', // 56
	'WebPanelLocationQuery_atl.general_atl.footer', // 57
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 58
	'WebStorageCategories', // 59
	'WelcomeMessagesQuery', // 60
	'WhiteboardUnifiedQuery', // 61
	'agg_ActiveCommentsQuery', // 62
	'agg_ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 63
	'agg_BlogTreeRootComponentQuery', // 64
	'agg_CollabDraftQuery', // 65
	'agg_ContentBlogUnifiedQuery', // 66
	'agg_ContentHeaderPresenceContentSettingsQuery', // 67
	'agg_ContentHeaderUnifiedQuery', // 68
	'agg_ContentTypesHeaderQuery', // 69
	'agg_ContentUnifiedQuery', // 70
	'agg_ContentUnifiedWithSpaceKeyQuery', // 71
	'agg_CoverPictureQuery', // 72
	'agg_CustomHeaderFooterQuery', // 73
	'agg_EditContentButtonQuery', // 74
	'agg_EditorContentStateQuery', // 75
	'agg_EditorPreferencesQuery', // 76
	'agg_EmojiTitleQuery', // 77
	'agg_EndOfPageRecommendationQuery', // 78
	'agg_FetchPreFilteredForgeAppsQuery_confluence_backgroundScript', // 79
	'agg_FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 80
	'agg_FetchPreFilteredForgeAppsQuery_confluence_globalPage', // 81
	'agg_FetchPreFilteredForgeAppsQuery_confluence_pageBanner', // 82
	'agg_FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 83
	'agg_FetchPreFilteredForgeAppsQuery_xen_macro', // 84
	'agg_FollowingFeedWithSortByStorageSnippetsQuery', // 85
	'agg_FooterCreateButtonsQuery', // 86
	'agg_GlobalNavigationComponentQuery', // 87
	'agg_HomeRecentWorkQuery', // 88
	'agg_LegacyMacroRendererQueryBodyQuery', // 89
	'agg_LivePagesByLineLastUpdatedQuery', // 90
	'agg_MainLayoutQuery', // 91
	'agg_NativeCollabQuery', // 92
	'agg_NotFoundContainerQuery', // 93
	'agg_NotificationsButtonQuery', // 94
	'agg_ObjectCommentContainerPreloadObjectCommentsQuery', // 95
	'agg_PageRestrictionsContextQuery', // 96
	'agg_PageTreeQuery', // 97
	'agg_PageTreeQueryWithSpaceKeyQuery', // 98
	'agg_PermissionCheckAddCommentQuery', // 99
	'agg_PersistentInviteEligibleQuery', // 100
	'agg_PersonalizedTemplatesV2AllTemplatesQuery', // 101
	'agg_PopularFeedWithTimeGranularityStorageSnippetsQuery', // 102
	'agg_PremiumTrialEotQuery', // 103
	'agg_ReactionsContentQuery', // 104
	'agg_RecentlyUpdatedMacroQuery', // 105
	'agg_RendererContentStateQuery', // 106
	'agg_RestrictedPageWithCanViewQuery', // 107
	'agg_ScreenQuery', // 108
	'agg_SiteInformationQuery', // 109
	'agg_SmartCreateFeedbackBannerQuery', // 110
	'agg_SpaceNavigationQuery', // 111
	'agg_SpaceOverviewIdQuery', // 112
	'agg_SpaceOverviewQuery', // 113
	'agg_SpaceRestrictionCheckQuery', // 114
	'agg_ThemeQuery', // 115
	'agg_TopNavigationQuery', // 116
	'agg_UserSettingsQuery', // 117
	'agg_ViewSpaceExternalCollaboratorsDialogQuery', // 118
	'agg_WebItemLocationQuery_page.metadata.banner', // 119
	'agg_WebItemLocationQuery_system.content.byline', // 120
	'agg_WebItemLocationQuery_system.header_left', // 121
	'agg_WebItemLocationQuery_system.header_left_system.user', // 122
	'agg_WebPanelLocationQuery_atl.footer', // 123
	'agg_WebPanelLocationQuery_atl.general', // 124
	'agg_WebPanelLocationQuery_atl.general_atl.footer', // 125
	'agg_WebPanelLocationQuery_atl.page.content.footer.actions', // 126
	'agg_WelcomeMessagesQuery', // 127
	'agg_contentAppearanceQuery', // 128
	'agg_fetchMentionsProviderDataQuery', // 129
	'agg_graphqlHelpersDSPIsActionEnabledForContentQuery', // 130
	'agg_graphqlHelpersFetchMediaTokenQuery', // 131
	'agg_multiMacroQueryQuery', // 132
	'agg_multiMacroQueryWithAppKeyQuery', // 133
	'agg_onboardingStateGetOnboardingStateQuery', // 134
	'agg_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 135
	'agg_onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 136
	'agg_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 137
	'agg_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 138
	'agg_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 139
	'agg_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 140
	'agg_onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 141
	'agg_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 142
	'agg_onboardingStateGetOnboardingStateQuery_nav4_isNav4CollapseReminderSpotlightDismissed', // 143
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_22', // 144
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 145
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 146
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 147
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 148
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 149
	'agg_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_150', // 150
	'agg_preloadAutohighlightsQuery', // 151
	'agg_preloadContentSmartLinksQuery', // 152
	'agg_preloadCreateSpaceQuery', // 153
	'agg_preloadEditButtonWithSpaceKeyQuery', // 154
	'agg_preloadEditorNodeDataProvidersDataQuery', // 155
	'agg_preloadLegacyBridgeQuery', // 156
	'agg_preloadOperationsQuery', // 157
	'agg_preloadPageStatusQueryDataQuery', // 158
	'agg_preloadPersonalSpaceDetailsQuery', // 159
	'agg_preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 160
	'agg_preloadTemplatesCollectionEligibleQuery', // 161
	'agg_useAnalyticsByLineQuery', // 162
	'agg_useAudioContentQuery', // 163
	'agg_useBlogPostsQueryQuery', // 164
	'agg_useCompanyHubPremiumGateCompanyHubPremiumGateQuery', // 165
	'agg_useConfluenceStandardToPremiumExperimentQuery', // 166
	'agg_useContentClassificationContentDataClassificationQuery', // 167
	'agg_useContributorsDataQuery', // 168
	'agg_useEditorContentModeValueQuery', // 169
	'agg_useEmojiEverSetPropertyQuery', // 170
	'agg_useFabricEligibilityMigrationQuery', // 171
	'agg_useFeatureDiscoveryFeatureDiscoveryQuery', // 172
	'agg_useFeedTypeSelectorRefreshQuery', // 173
	'agg_useFollowingFeedWithSortByStorageFeedContentQuery', // 174
	'agg_useGetCurrentStorageUsageQuery', // 175
	'agg_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 176
	'agg_useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 177
	'agg_useHomeWidgetStateQuery', // 178
	'agg_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 179
	'agg_useIsLoomEntryPointsEnabledQuery', // 180
	'agg_useIsUserViewingSpaceAsAnonQuery', // 181
	'agg_useLicensedProductsQueryForGlobalAppShortcutsQuery', // 182
	'agg_useLoomTenantProvisionStatusQuery', // 183
	'agg_usePopularFeedWithTimeGranularityStorageQuery', // 184
	'agg_usePreloadCommentButtonQuery', // 185
	'agg_useReadTimeQuery', // 186
	'agg_useRegisterAdminAnnouncementBannerQuery', // 187
	'agg_useShareAndRestrictButtonDataQuery', // 188
	'agg_useShortcutsSpaceNavigationQuery', // 189
	'agg_useSpaceBaseQueryBaseQuery', // 190
	'agg_useSpaceDetailQuery', // 191
	'agg_useSpaceViewsDataSpaceRootQuery', // 192
	'agg_useSpaceViewsOptionsPersistenceQuery', // 193
	'agg_useSpacesDataMyVisitedSpacesQuery', // 194
	'agg_useSpacesDataStarredSpacesQuery', // 195
	'agg_useTitleContentPropertiesForEditorQuery', // 196
	'agg_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 197
	'agg_useTitleContentPropertiesForPublishedPageQuery', // 198
	'agg_useUserByLicensedProductsQuery', // 199
	'agg_useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery', // 200
	'contentAppearanceQuery', // 201
	'contentSmartLinksORS', // 202
	'fetchMentionsProviderDataQuery', // 203
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 204
	'graphqlHelpersFetchMediaTokenQuery', // 205
	'multiMacroQueryWithAppKeyQuery', // 206
	'onboardingStateGetOnboardingStateQuery', // 207
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 208
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 209
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 210
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 211
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 212
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 213
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 214
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_22', // 215
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 216
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 217
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 218
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 219
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 220
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_150', // 221
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 222
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_156', // 223
	'pageButtons', // 224
	'preloadContentSmartLinksQuery', // 225
	'preloadCreateSpaceQuery', // 226
	'preloadEditButtonWithSpaceKeyQuery', // 227
	'preloadEditorNodeDataProvidersDataQuery', // 228
	'preloadLegacyBridgeQuery', // 229
	'preloadOperationsQuery', // 230
	'preloadPageStatusQueryDataQuery', // 231
	'preloadPersonalSpaceDetailsQuery', // 232
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 233
	'preloadSpaceBlogCountQuery', // 234
	'preloadTemplatesCollectionEligibleQuery', // 235
	'rightPanel', // 236
	'searchCombinedConfig', // 237
	'searchResults', // 238
	'sidenavSmartLinksORS', // 239
	'useAnalyticsByLineQuery', // 240
	'useAudioContentQuery', // 241
	'useBlogPostsQueryQuery', // 242
	'useConfluenceStandardToPremiumExperimentQuery', // 243
	'useContentClassificationContentDataClassificationQuery', // 244
	'useContributorsDataQuery', // 245
	'useEditorContentModeValueQuery', // 246
	'useEmojiEverSetPropertyQuery', // 247
	'useFabricEligibilityMigrationQuery', // 248
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 249
	'useFeedTypeSelectorRefreshQuery', // 250
	'useGetCurrentStorageUsageQuery', // 251
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 252
	'useHomeWidgetStateQuery', // 253
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 254
	'useIsUserViewingSpaceAsAnonQuery', // 255
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 256
	'useLoomTenantProvisionStatusQuery', // 257
	'usePreloadCommentButtonQuery', // 258
	'useReadTimeQuery', // 259
	'useRegisterAdminAnnouncementBannerQuery', // 260
	'useShareAndRestrictButtonDataQuery', // 261
	'useShortcutsSpaceNavigationQuery', // 262
	'useSpaceBaseQueryBaseQuery', // 263
	'useSpaceDetailQuery', // 264
	'useSpaceEnabledContentTypesQuery', // 265
	'useSpaceViewsDataSpaceRootQuery', // 266
	'useSpaceViewsOptionsPersistenceQuery', // 267
	'useSpacesDataAnonymousSpacesQuery', // 268
	'useSpacesDataMyVisitedSpacesQuery', // 269
	'useSpacesDataStarredSpacesQuery', // 270
	'useTitleContentPropertiesForEditorQuery', // 271
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 272
	'useTitleContentPropertiesForPublishedPageQuery', // 273
	'useUserByLicensedProductsQuery', // 274
];

// prettier-ignore
const R: Readonly<Record<string, string>> = {
	'prod-apne': '0001321982e527200000884080000000000000000000000000001d0044d00800714000', /* 38 fast, 3 slow, 112 excl */
	'prod-apne2': '0001321982e527200000884080000000000000000000000000001d0044900808714000', /* 38 fast, 4 slow, 154 excl */
	'prod-apse': '0019361982e727200000884080000000000000000000000000201d0044d00800715000', /* 44 fast, 2 slow, 213 excl */
	'prod-apse2': '0009361982e727200000884080000000000000000000000000201d0044d00808717000', /* 45 fast, 2 slow, 211 excl */
	'prod-apsouth': '0001321982e527200000884080000000000000000000000000001d0044d00808716000', /* 40 fast, 2 slow, 64 excl */
	'prod-cacentral': '0009329982e527200000884080000000000000000000000000001d0044d00800716000', /* 41 fast, 0 slow, 149 excl */
	'prod-east': 'cdbb36d996e7afe53916d8409be5fc5aac0a8273880ad0be4f701d01e6d04b09777d02', /* 139 fast, 7 slow, 142 excl */
	'prod-eucentral': '4879361982e7a7292010984080203c02800a80200000500800201d0044d05808715502', /* 74 fast, 4 slow, 203 excl */
	'prod-eucentral2': '0009321982e527200000084080000000000000000000000000001d0044800800716000', /* 37 fast, 4 slow, 103 excl */
	'prod-euwest': 'cdfb36d992e7af253916d84093e17c1aa80a80208002d0bc43701d00e6d44a09777d02', /* 121 fast, 7 slow, 153 excl */
	'prod-euwest2': '0009329982e527200000884080000000000000000000000000001d0044d00808716000', /* 42 fast, 0 slow, 184 excl */
	'prod-west2': '0039369982e7a7292010d84091a07c02800a80200000502800201d0044d05808715102', /* 77 fast, 2 slow, 188 excl */
	'stg-east': '0008000002000008008087680000000000868000608002000000044000100000000000', /* 22 fast, 238 slow, 50 excl */
};

const _cache = new Map<string, ReadonlySet<string>>();

function _decode(region: string): ReadonlySet<string> {
	const cached = _cache.get(region);
	if (cached) return cached;
	const hex = R[region];
	if (!hex) return _empty;
	const set = new Set<string>();
	for (let i = 0; i < Q.length; i++) {
		// eslint-disable-next-line no-bitwise
		const byteIdx = i >> 3;
		// eslint-disable-next-line no-bitwise
		const bitIdx = i & 7;
		const byte = parseInt(hex.slice(byteIdx * 2, byteIdx * 2 + 2), 16);
		// eslint-disable-next-line no-bitwise
		if (byte & (1 << bitIdx)) set.add(Q[i]);
	}
	const frozen = Object.freeze(set) as ReadonlySet<string>;
	_cache.set(region, frozen);
	return frozen;
}

const _empty: ReadonlySet<string> = Object.freeze(new Set<string>());

/**
 * Check whether a preload query is classified as fast (batchable) for the
 * current SSR region.
 *
 * @param queryName — the GraphQL operation name.
 * @param region — SSR region override; defaults to window.__SSR_REGION__.
 */
export function isFastPreloadQuery(
	queryName: string,
	region: string = typeof __SSR_REGION__ !== 'undefined' ? __SSR_REGION__ : '',
): boolean {
	return _decode(region).has(queryName);
}
